<template>
  <div>
    <div class="tabs is-boxed">
      <ul>
        <router-link :to="{ name: 'client-bets-redpipe' }" active-class="is-active" tag="li"><a>RedPipe</a></router-link>
        <router-link :to="{ name: 'client-bets-flg' }" active-class="is-active" tag="li"><a>FLG</a></router-link>
        <router-link :to="{ name: 'client-bets-hdraces' }" active-class="is-active" tag="li"><a>HdRaces</a></router-link>
        <router-link :to="{ name: 'client-bets-bk' }" active-class="is-active" tag="li"><a>Bookmaker</a></router-link>
        <router-link :to="{ name: 'client-bets-tvbet' }" active-class="is-active" tag="li"><a>TVBet</a></router-link>
        <router-link :to="{ name: 'client-bets-covid' }" active-class="is-active" tag="li"><a>COVID</a></router-link>
      </ul>
    </div>

    <router-view />
  </div>
</template>
<script>
  export default {
    name: 'client-bets'
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/bets/index.vue